import React, { createContext, useContext } from "react";
import useAuth from "../../hooks/Auth/useAuth";
import useRTSP from "../../hooks/useRTSP";

const RTSPContext = createContext({ cameraMap: {}, getStream: () => {} });

export function RTSPProvider({ children }) {
  const { relevantSite } = useAuth();         // comes from your AuthProvider
  const { cameraMap, getStream } = useRTSP(relevantSite);

  return (
    <RTSPContext.Provider value={{ cameraMap, getStream, relevantSite }}>
      {children}
    </RTSPContext.Provider>
  );
}

export default function useRTSPContext() {
  return useContext(RTSPContext);
}
